import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
const NextArrow = (props) => {
    const { className, customStyle, dataAttributes, disabled, onClick, style } = props;
    return (_jsx("button", Object.assign({ "aria-label": 'Next', className: `${className} material-icons`, disabled: disabled, onClick: onClick, style: Object.assign(Object.assign({}, style), customStyle), type: 'button' }, dataAttributes, { children: "keyboard_arrow_right" })));
};
NextArrow.propTypes = {
    className: propStr(),
    customStyle: propShape(),
    dataAttributes: propShape().isRequired,
    disabled: propBool(),
    onClick: propFunc(),
    style: propShape(),
};
NextArrow.defaultProps = {
    className: 'slick-next',
    customStyle: {},
    disabled: false,
    onClick: null,
    style: {},
};
export default NextArrow;
